"use strict";
import _ from "underscore";
export default {
  queryWithFilters(filters) {
    return _.extend({}, { filters });
  }
};
